import { render, staticRenderFns } from "./irrigation.vue?vue&type=template&id=66203022&scoped=true"
import script from "./irrigation.vue?vue&type=script&lang=js"
export * from "./irrigation.vue?vue&type=script&lang=js"
import style0 from "./irrigation.vue?vue&type=style&index=0&id=66203022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66203022",
  null
  
)

export default component.exports